import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const DataValidation = React.lazy(async () => ({
    default: (await import('@oc/data-validation/module')).DataValidationModule
}))

export function DataValidationComponent() {
    return <SuspenseWhileLoading LazyComponent={DataValidation} />
}
